<template>
    <li class="nav-item dropdown"
        v-if="activeDropdownTabs.length > 0 || authenticated"
    >
        <a class="nav-link dropdown-toggle" href="#" role="button"
           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Witaj<span v-if="authenticated">, {{ username }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="#"
               v-for="tab in activeDropdownTabs"
               :key="tab.name"
               @click="emitTab(tab)"
            >
                {{ tab.name }}
            </a>
            <div class="dropdown-divider" v-if="activeDropdownTabs.length > 0 && authenticated"></div>
            <div v-if="authorizedApps.length > 1">
                <a class="dropdown-item" v-for="app in authorizedApps" :href="app.href" v-bind:class="{ 'current-link' : app.name === currentApp}">
                    <span v-if="app.name === currentApp">&#9657</span> {{ app.displayName }}
                </a>
                <div class="dropdown-divider" v-if="authenticated"></div>
            </div>
            <a class="dropdown-item" href="#"
               v-if="authenticated"
               @click="logout()">Wyloguj się</a>
        </div>
    </li>
</template>

<script>
    import Constants from '../constants.js';

    export default {
        name: 'NavbarDropdown',
        props: {
            activeDropdownTabs: Array,
            currentApp: {
                type: String,
                required: true,
                validator: value => Constants.get('APP_NAMES').indexOf(value) >= 0,
            },
        },
        computed: {
            authenticated() {
                return this.$store.getters['auth/authenticated'];
            },
            username() {
                return this.$store.getters['auth/username'];
            },
            authorizedApps() {
                return this.$store.getters['auth/apps'].filter(e => e.authorized);
            },
        },
        methods: {
            emitTab(tab) {
                if (tab.component) {
                    this.$emit('click', tab);
                }
                else if (tab.href) {
                    window.location.href = tab.href;
                }
            },
            logout() {
                this.$emit('logout');
            },
        }
    }
</script>

<style lang="scss" scoped>
    .current-link {
        color: #ff6200;
    }
    .dropdown-item {
        font-weight:500;
    }
</style>


// WEBPACK FOOTER //
// NavbarDropdown.vue?61729636